export * from './src/iam-recovery-v1-recovery-recovery.universal.js';
